export const getTrackingUserId = (getters) => {
	const {applicationUserLoggedIn, customerDetails, globalSelectedShop} = getters;

	const userTrackingId = globalSelectedShop &&
		globalSelectedShop.shopOptions &&
		globalSelectedShop.shopOptions.userTrackingId &&
		globalSelectedShop.shopOptions.userTrackingId.id;

	const isKiosk = getters.channelAlias === "kiosk";

	if (isKiosk && !applicationUserLoggedIn && !!userTrackingId) {
		return userTrackingId;
	}

	const userTrackingUserId = ((customerDetails || {}).meta || {}).helloRetailTrackingUserId;

	return applicationUserLoggedIn ? userTrackingUserId : localStorage.getItem("helloRetail_trackingUserId_guest");
};
